import { Component, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  template: `
    <div *nzModalTitle>
      <span
        nz-icon
        nzType="question-circle"
        nzTheme="outline"
        style="float: right; margin-left: 16px; font-size: 22px; color: red;"
      ></span>
      <span>{{ title }}</span>
    </div>
    <div>{{ subTitle }}</div>
    <div>
      <input nz-input [placeholder]="placeholder" [(ngModel)]="confirmNumber" />
    </div>
    <div *nzModalFooter>
      <button
        nz-button
        nzType="primary"
        nzDanger
        (click)="ok()"
        [disabled]="disabled"
      >
        אישור
      </button>
      <button nz-button nzType="default" (click)="cancel()">ביטול</button>
    </div>
  `
})
export class NzModalConfirmActionComponent {
  @Input() confirmNumber?: number;
  @Input() randomNumber?: number;
  @Input() title?: string;
  @Input() subTitle?: string;
  placeholder: string;

  get disabled(): boolean {
    return Number(this.confirmNumber) !== this.randomNumber;
  }

  constructor(private modal: NzModalRef) {
    this.randomNumber = Math.floor(1000 + Math.random() * 9000);
    this.placeholder = `לאישור הקש/י את המספר הבא: ${this.randomNumber}`;
  }

  ok(): void {
    this.modal.triggerOk();
  }

  cancel(): void {
    this.modal.triggerCancel();
  }
}
